import { render, staticRenderFns } from "./extended-preferences-translations-tab.vue?vue&type=template&id=7dda4ad0"
import script from "./extended-preferences-translations-tab.vue?vue&type=script&lang=js"
export * from "./extended-preferences-translations-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports